/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RecommendationDTO,
    RecommendationDTOFromJSON,
    RecommendationDTOFromJSONTyped,
    RecommendationDTOToJSON,
} from './RecommendationDTO';
import {
    ReportType,
    ReportTypeFromJSON,
    ReportTypeFromJSONTyped,
    ReportTypeToJSON,
} from './ReportType';

/**
 * 
 * @export
 * @interface AddBaseReportDTO
 */
export interface AddBaseReportDTO {
    /**
     * 
     * @type {Date}
     * @memberof AddBaseReportDTO
     */
    reportDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof AddBaseReportDTO
     */
    studyProgramId?: string;
    /**
     * 
     * @type {Blob}
     * @memberof AddBaseReportDTO
     */
    file?: Blob | null;
    /**
     * 
     * @type {string}
     * @memberof AddBaseReportDTO
     */
    description?: string | null;
    /**
     * 
     * @type {ReportType}
     * @memberof AddBaseReportDTO
     */
    reportType?: ReportType;
    /**
     * 
     * @type {string}
     * @memberof AddBaseReportDTO
     */
    reportTypeValue?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof AddBaseReportDTO
     */
    startDate?: Date | null;
    /**
     * 
     * @type {Array<RecommendationDTO>}
     * @memberof AddBaseReportDTO
     */
    readonly recommendations?: Array<RecommendationDTO> | null;
    /**
     * 
     * @type {string}
     * @memberof AddBaseReportDTO
     */
    recommendationsJson?: string | null;
}

export function AddBaseReportDTOFromJSON(json: any): AddBaseReportDTO {
    return AddBaseReportDTOFromJSONTyped(json, false);
}

export function AddBaseReportDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddBaseReportDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'reportDate': !exists(json, 'reportDate') ? undefined : (new Date(json['reportDate'])),
        'studyProgramId': !exists(json, 'studyProgramId') ? undefined : json['studyProgramId'],
        'file': !exists(json, 'file') ? undefined : json['file'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'reportType': !exists(json, 'reportType') ? undefined : ReportTypeFromJSON(json['reportType']),
        'reportTypeValue': !exists(json, 'reportTypeValue') ? undefined : json['reportTypeValue'],
        'startDate': !exists(json, 'startDate') ? undefined : (json['startDate'] === null ? null : new Date(json['startDate'])),
        'recommendations': !exists(json, 'recommendations') ? undefined : (json['recommendations'] === null ? null : (json['recommendations'] as Array<any>).map(RecommendationDTOFromJSON)),
        'recommendationsJson': !exists(json, 'recommendationsJson') ? undefined : json['recommendationsJson'],
    };
}

export function AddBaseReportDTOToJSON(value?: AddBaseReportDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'reportDate': value.reportDate === undefined ? undefined : (value.reportDate.toISOString()),
        'studyProgramId': value.studyProgramId,
        'file': value.file,
        'description': value.description,
        'reportType': ReportTypeToJSON(value.reportType),
        'reportTypeValue': value.reportTypeValue,
        'startDate': value.startDate === undefined ? undefined : (value.startDate === null ? null : value.startDate.toISOString()),
        'recommendationsJson': value.recommendationsJson,
    };
}

